module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"username":"Username","pwd":"reset password"},"zh-CN":{"username":"学生账号为","pwd":"重置密码为"},"zh-TW":{"username":"學生賬號為","pwd":"重置密碼為"},"it":{"username":"Username","pwd":"resetta la password"},"id":{"username":"Nama Pengguna","pwd":"Atur ulang kata sandi"}}')
  delete Component.options._Ctor
}
